var React = require('react');

class Error extends React.Component {
  render() {
    return (
      <div style={ { textAlign: 'center' } }>
        <div className="container">
          <div className="underconstruction" />
          <h1> Work under progress </h1>
          <p className="text-danger" style={ { 'fontSize': '22px' } }>This page is currently under construction. </p>
        </div>
      </div>
      );
  }
}

export default Error;


// WEBPACK FOOTER //
// ./src/components/Error.js